'use client';

import { RadioTile, RadioTiles, VariantState } from '@bytel/trilogy-react';

import { type FaiProduct, RangesNewGeneration } from '@app-types/fai';

type OfferRadioListProps = {
    faiProducts: FaiProduct[];
    selectedOffer?: FaiProduct | null;
    onChangeOffer: (product: FaiProduct) => void;
};

export default function OfferRadioList({ faiProducts, selectedOffer, onChangeOffer }: Readonly<OfferRadioListProps>) {
    return (
        <RadioTiles className='grid-radio-list fai-grid'>
            {faiProducts.map((product) => {
                const speedDown = product.pre_elig_speed_down
                    ? `${product.pre_elig_speed_down}\u00A0Gb/s`
                    : product.speedDown;
                const speedUp = product.pre_elig_speed_up ? `${product.pre_elig_speed_up}\u00A0Gb/s` : product.speedUp;
                const isAnniversaryMSL =
                    product.commercial_series === 'serie_speciale' &&
                    (product.range_ng === RangesNewGeneration.VERY_FIT ||
                        product.range_ng === RangesNewGeneration.ULTYM);
                return (
                    <RadioTile
                        key={product.id}
                        className='is-fullheight'
                        name='fai-offer'
                        data-testid={`label-bbox-${product.range_ng === RangesNewGeneration.VERY_FIT ? 'otis' : 'tv'}-${product.id}`}
                        id={product.id.toString()}
                        label={product.selector_title ?? product.title}
                        description={
                            <>
                                ↓&nbsp;{speedDown}&nbsp;&nbsp;↑&nbsp;{speedUp}
                            </>
                        }
                        checked={product.gencode_offre === selectedOffer?.gencode_offre}
                        onChange={() => onChangeOffer(product)}
                        value={product.id.toString()}
                        horizontal
                        sticker={isAnniversaryMSL ? 'Edition spéciale' : undefined}
                        stickerVariant={VariantState.MAIN}
                    />
                );
            })}
        </RadioTiles>
    );
}
